<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <div class="table">
          <div class="prospectus_title">
            {{inforList.real_name}}-创业计划书
          </div>
          <div class="content_block">
            <h3>基本信息</h3>
            <div class="content_table enterprise_table">
              <table>
                <tr>
                  <td>公司名称:</td>
                  <td>{{inforList.enterprise_name}}</td>
                </tr>
                <tr>
                  <td>创业者姓名：</td>
                  <td>{{inforList.real_name}}</td>
                </tr>
                <tr>
                  <td>联系电话：</td>
                  <td>{{inforList.telephone}}</td>
                </tr>
                <tr>
                  <td>通讯地址：</td>
                  <td>{{inforList.address}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="content_block">
            <h3>企业概况</h3>
            <div class="content_table enterprise_table">
              <table>
                <tr>
                  <td>主要经营范围：</td>
                  <td>{{inforList.manage_scope}}</td>
                </tr>
                <tr>
                  <td>企业类型：</td>
                  <td v-if="!enterpriseTypeOther">
                    <span v-for="(item,index) in enterpriseType" :key="index">{{item}}<span v-if="index != enterpriseType.length -1">，</span></span>
                  </td>
                  <td v-else>{{enterpriseOtherText}}</td>
                </tr>
                <tr>
                  <td>创业目的：</td>
                  <td>{{inforList.purpose}}</td>
                </tr>
                <tr>
                  <td>企业愿景：</td>
                  <td>{{inforList.enterprise_vision}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="content_block">
            <h3>创业计划作者的个人情况</h3>
            <div class="content_table enterprise_table">
              <table>
                <thead>
                  <tr>
                    <td>个人情况：</td>
                    <td>时间</td>
                    <td>经验</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.person_situation" :key="index">
                    <td></td>
                    <td>{{item.time}}</td>
                    <td>{{item.experience}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>教育背景：</td>
                    <td>时间</td>
                    <td>教育</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.person_education" :key="index">
                    <td></td>
                    <td>{{item.time}}</td>
                    <td>{{item.education}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="content_block">
            <h3>市场评估</h3>
            <div class="content_table enterprise_table">
              <table>
                <tr>
                  <td>目标客户描述：</td>
                  <td>{{inforList.target_customer}}</td>
                </tr>
                <tr>
                  <td>预计市场占有率：</td>
                  <td>{{inforList.market_share}}</td>
                </tr>
                <tr>
                  <td>市场容量变化趋势：</td>
                  <td>{{inforList.market_trend}}</td>
                </tr>
                <tr>
                  <td>竞争对手优势：</td>
                  <td>{{inforList.opponent_advantage}}</td>
                </tr>
                <tr>
                  <td>竞争对手劣势：</td>
                  <td>{{inforList.opponent_disadvantage}}</td>
                </tr>
                <tr>
                  <td>本企业相对于竞争对手的优势：</td>
                  <td>{{inforList.our_advantage}}</td>
                </tr>
                <tr>
                  <td>本企业相对于竞争对手的劣势：</td>
                  <td>{{inforList.our_disadvantage}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="content_block">
            <h3>市场营销计划</h3>
            <div class="content_table enterprise_table">
              <table >
                <thead>
                  <tr>
                    <td>产品或服务：</td>
                    <td>产品或服务</td>
                    <td>特征</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.product_service" :key="index">
                    <td></td>
                    <td>{{item.product}}</td>
                    <td>{{item.feature}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>价格：</td>
                    <td>产品或服务</td>
                    <td>预测成本价格</td>
                    <td>预测销售价格</td>
                    <td>竞争对手价格</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.price" :key="index">
                    <td></td>
                    <td>{{item.product}}</td>
                    <td>{{item.cost_price}}</td>
                    <td>{{item.sell_price}}</td>
                    <td>{{item.opponent_price}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>选址细节：</td>
                    <td>地址</td>
                    <td>面积(平方米)</td>
                    <td>租金或成本</td>
                    <td>选址原因</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td></td>
                    <td>{{inforList.select_address}}</td>
                    <td>{{inforList.select_area}}</td>
                    <td>{{inforList.select_rent}}</td>
                    <td>{{inforList.address_reson}}</td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tr>
                  <td>销售方式：</td>
                  <td v-if="!saleTypeOther">
                    <span v-for="(item,index) in saleType" :key="index">{{item}}<span v-if="index != saleType.length -1">，</span></span>
                  </td>
                  <td v-else>{{saleOtherText}}</td>
                </tr>
                <tr>
                  <td>选择该销售方式的原因：</td>
                  <td>{{inforList.sale_reson}}</td>
                </tr>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>促销</td>
                    <td>促销方式</td>
                    <td></td>
                    <td>成本预测名称</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.promotion" :key="index">
                    <td></td>
                    <td>{{item.mode}}</td>
                    <td>{{item.mode_name}}</td>
                    <td>{{item.cost_forecast}}</td>
                    <td>{{item.cost_value}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="content_block">
            <h3>企业组织机构</h3>
            <div class="content_table enterprise_table">
              <table>
                <tr>
                  <td>登记类型：</td>
                  <td v-if="!registerTypeOther">{{registerType}}</td>
                  <td v-else>{{registerOtherText}}</td>
                </tr>
                <tr>
                  <td>拟定的企业名称:</td>
                  <td>{{inforList.company_name}}</td>
                </tr>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>企业成员：</td>
                    <td>职务</td>
                    <td>薪资/月</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.member" :key="index">
                    <td></td>
                    <td>{{item.position}}</td>
                    <td>{{item.pay}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table width_table">
                <thead>
                  <tr>
                    <td>获取的营业执照、许可证：</td>
                    <td>类型</td>
                    <td>预计费用</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.license" :key="index">
                    <td></td>
                    <td>{{item.type}}</td>
                    <td>{{item.cost}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table width1_table">
                <thead>
                  <tr>
                    <td>企业承担的其他法律责任（保险、纳税等）：</td>
                    <td>种类</td>
                    <td>预计费用</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.legal_liability" :key="index">
                    <td></td>
                    <td>{{item.type}}</td>
                    <td>{{item.cost}}</td>
                  </tr>
                </tbody>
              </table>
              <ul class="next_table table_ul">
                <li>
                  <div class="table_li_title">股份合作协议：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index" ></div>
                </li>
                <li >
                  <div class="table_li_title">合作人：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.cooperate_name}}</div>
                </li>
                <li>
                  <div class="table_li_title">计划注册资金：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.fund}}</div>
                </li>
                <li>
                  <div class="table_li_title">出资方式：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.investe_type}}</div>
                </li>
                <li>
                  <div class="table_li_title">出资数额：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.investe_amont}}</div>
                </li>
                <li>
                  <div class="table_li_title">股权份额及利润分配：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.profit}}</div>
                </li>
                <li>
                  <div class="table_li_title">利润数额与亏损承担：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.bear}}</div>
                </li>
                <li>
                  <div class="table_li_title">分工、权限和责任：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.duty}}</div>
                </li>
                <li>
                  <div class="table_li_title">违约责任：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.break_promise}}</div>
                </li>
                <li>
                  <div class="table_li_title">转股、退股及增资：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.withdraw}}</div>
                </li>
                <li>
                  <div class="table_li_title">协议变更和终止：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.termination}}</div>
                </li>
                <li>
                  <div class="table_li_title">其他条款：</div>
                  <div class="table_td" v-for="(item,index) in inforList.cooperate_agreement" :key="index">{{item.other_terms}}</div>
                </li>
              </ul>
              <div class="table_ul">
                <li>
                  <div class="table_li_title">企业组织结构图：</div>
                  <div class="table_td">
                    <img :src="inforList.enterprise_image" v-if="inforList.enterprise_image">
                  </div>
                </li>
              </div>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>机器、机械和其他生产设备：</td>
                    <td>项目</td>
                    <td>数量</td>
                    <td>单价</td>
                    <td>金额</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.machine" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.num}}</td>
                    <td>{{item.price}}</td>
                    <td>{{item.money}}</td>
                  </tr>
                </tbody>
              </table>
              <table>
                <thead>
                  <tr>
                    <td>供应商名称</td>
                    <td>地址</td>
                    <td>电话或传真</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.machine_provider" :key="index">
                    <td>{{item.name}}</td>
                    <td>{{item.address}}</td>
                    <td>{{item.telephone}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>器具、工具和家具：</td>
                    <td>项目</td>
                    <td>数量</td>
                    <td>单价</td>
                    <td>金额</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.tool" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.num}}</td>
                    <td>{{item.price}}</td>
                    <td>{{item.money}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>交通工具：</td>
                    <td>项目</td>
                    <td>数量</td>
                    <td>单价</td>
                    <td>金额</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.vehicle" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.num}}</td>
                    <td>{{item.price}}</td>
                    <td>{{item.money}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="">
                <thead>
                  <tr>
                    <td>供应商名称</td>
                    <td>地址</td>
                    <td>电话或传真</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.vehicle_provider" :key="index">
                    <td>{{item.name}}</td>
                    <td>{{item.address}}</td>
                    <td>{{item.telephone}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>电子设备：</td>
                    <td>项目</td>
                    <td>数量</td>
                    <td>单价</td>
                    <td>金额</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.electronic" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.num}}</td>
                    <td>{{item.price}}</td>
                    <td>{{item.money}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="">
                <thead>
                  <tr>
                    <td>供应商名称</td>
                    <td>地址</td>
                    <td>电话或传真</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.electronic_provider" :key="index">
                    <td>{{item.name}}</td>
                    <td>{{item.address}}</td>
                    <td>{{item.telephone}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>无形资产：</td>
                    <td>项目</td>
                    <td>金额</td>
                    <td>备注</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.intangible_asset" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.money}}</td>
                    <td>{{item.remark}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>开办费用：</td>
                    <td>项目</td>
                    <td>金额</td>
                    <td>备注</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.formation_expense" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.money}}</td>
                    <td>{{item.remark}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>其他投入：</td>
                    <td>项目</td>
                    <td>金额</td>
                    <td>备注</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.other_fund" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.money}}</td>
                    <td>{{item.remark}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>投资概要：</td>
                    <td>项目</td>
                    <td>金额</td>
                    <td>月折旧额/摊销额</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.investment" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.money}}</td>
                    <td>{{item.depreciation}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="content_block">
            <h3>流动资金</h3>
            <div class="content_table enterprise_table">
              <table>
                <thead>
                  <tr>
                    <td>原材料（或商品）和包装费：</td>
                    <td>项目</td>
                    <td>数量</td>
                    <td>单价</td>
                    <td>金额</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.material" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.num}}</td>
                    <td>{{item.price}}</td>
                    <td>{{item.money}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="">
                <thead>
                  <tr>
                    <td>供应商名称</td>
                    <td>地址</td>
                    <td>电话或传真</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.material_provider" :key="index">
                    <td>{{item.name}}</td>
                    <td>{{item.address}}</td>
                    <td>{{item.telephone}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table">
                <thead>
                  <tr>
                    <td>其他经营费用：</td>
                    <td>项目</td>
                    <td>金额</td>
                    <td>备注</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.other_fund" :key="index">
                    <td></td>
                    <td>{{item.project}}</td>
                    <td>{{item.money}}</td>
                    <td>{{item.remark}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="content_block">
            <h3>销售收入预测（12个月）</h3>
            <div class="content_table enterprise_table">
              <table v-for="(item,index) in inforList.income_forecast" :key="index" :class="{next_table:index != 0}">
                <thead>
                  <tr>
                    <td>{{item.name}}</td>
                    <td>月/季/年</td>
                    <td>销售数量</td>
                    <td>平均单价</td>
                    <td>月销售额</td>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for="(item,index) in item.forecast" :key="index">
                    <td></td>
                    <td v-if="item.year != 13">{{item.year}}</td>
                    <td v-if="item.year === 13">合计</td>
                    <td>{{item.num}}</td>
                    <td>{{item.price}}</td>
                    <td>{{item.saleroom}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="content_block">
            <h3>销售和成本计划</h3>
            <div class="content_table enterprise_table">
              <table >
                <thead>
                  <tr>
                    <td>销售</td>
                    <td>月/季/年</td>
                    <td>含税销售收入</td>
                    <td>增值税</td>
                    <td>净收入</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in inforList.sell" :key="index" >
                    <td></td>
                    <td v-if="item.year != 13">{{item.year}}</td>
                    <td v-if="item.year === 13">合计</td>
                    <td>{{item.income}}</td>
                    <td>{{item.add_tax}}</td>
                    <td>{{item.net_income}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table long_table">
                <thead>
                  <tr>
                    <td>成本</td>
                    <td>名称</td>
                    <td>1</td>
                    <td>2</td>             
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>6</td>
                    <td>7</td>
                    <td>8</td>
                    <td>9</td>
                    <td>10</td>
                    <td>11</td>
                    <td>12</td>
                    <td>合计</td>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item,index) in inforList.cost" >
                    <tr :key="index">
                      <td></td>
                      <td>{{item.project}}</td>
                      <td>{{item.jan}}</td>   
                      <td>{{item.feb}}</td>
                      <td>{{item.mar}}</td> 
                      <td>{{item.apr}}</td>
                      <td>{{item.may}}</td>
                      <td>{{item.jun}}</td>
                      <td>{{item.jul}}</td>
                      <td>{{item.aug}}</td>
                      <td>{{item.spe}}</td>
                      <td>{{item.oct}}</td>
                      <td>{{item.nov}}</td>
                      <td>{{item.dec}}</td>
                      <td>{{item.total}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <table  class="next_table">
                <thead>
                  <tr>
                    <td>所得税</td>
                    <td>月/季/年</td>
                    <td>企业所得税</td>
                    <td>个人所得税</td>
                    <td>其他</td>
                  </tr>
                </thead>
                <tbody>
                  <tr   v-for="(item,index) in inforList.income_tax" :key="index" >
                    <td></td>
                    <td v-if="item.year != 13">{{item.year}}</td>
                    <td v-if="item.year === 13">合计</td>
                    <td>{{item.enterprise}}</td>
                    <td>{{item.person}}</td>
                    <td>{{item.other}}</td>
                  </tr>
                </tbody>
              </table>
              <table  class="next_table">
                <thead>
                  <tr>
                    <td>利润</td>
                    <td>月/季/年</td>
                    <td>附加税</td>
                    <td>利润</td>
                    <td>净利润</td>
                  </tr>
                </thead>
                <tbody>
                  <tr   v-for="(item,index) in inforList.profit" :key="index" >
                    <td></td>
                    <td v-if="item.year != 13">{{item.year}}</td>
                    <td v-if="item.year === 13">合计</td>
                    <td>{{item.enterprise}}</td>
                    <td>{{item.person}}</td>
                    <td>{{item.other}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="content_block">
            <h3>现金流量计划</h3>
            <div class="content_table enterprise_table">
              <table >
                <thead>
                  <tr>
                    <td>现金流入</td>
                    <td>月/季/年</td>
                    <td>现金销售收入</td>
                    <td>赊账销售收入</td>
                    <td>贷款</td>
                    <td>股东投资</td>
                    <td>现金流入合计</td>
                  </tr>
                </thead>
                <tbody>
                  <tr   v-for="(item,index) in inforList.cash_inflow" :key="index" >
                    <td></td>
                    <td v-if="item.year != 13">{{item.year}}</td>
                    <td v-if="item.year === 13">合计</td>
                    <td>{{item.cash}}</td>
                    <td>{{item.account}}</td>
                    <td>{{item.loan}}</td>
                    <td>{{item.shareholder}}</td>
                    <td>{{item.cash_count}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="next_table long_table">
                <thead>
                  <tr>
                    <td>现金流出</td>
                    <td>名称</td>
                    <td>1</td>
                    <td>2</td>             
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>6</td>
                    <td>7</td>
                    <td>8</td>
                    <td>9</td>
                    <td>10</td>
                    <td>11</td>
                    <td>12</td>
                    <td>合计</td>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item,index) in inforList.cash_outflow" >
                    <tr :key="index">
                      <td></td>
                      <td>{{item.project}}</td>
                      <td>{{item.jan}}</td>   
                      <td>{{item.feb}}</td>
                      <td>{{item.mar}}</td> 
                      <td>{{item.apr}}</td>
                      <td>{{item.may}}</td>
                      <td>{{item.jun}}</td>
                      <td>{{item.jul}}</td>
                      <td>{{item.aug}}</td>
                      <td>{{item.spe}}</td>
                      <td>{{item.oct}}</td>
                      <td>{{item.nov}}</td>
                      <td>{{item.dec}}</td>
                      <td>{{item.total}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <table  class="next_table">
                <thead>
                  <tr>
                    <td>月初——月末</td>
                    <td>月/季/年</td>
                    <td>月初现金</td>
                    <td>月末现金</td>
                  </tr>
                </thead>
                <tbody>
                  <tr   v-for="(item,index) in inforList.begin_end" :key="index" >
                    <td></td>
                    <td v-if="item.year != 13">{{item.year}}</td>
                    <td v-if="item.year === 13">合计</td>
                    <td>{{item.begin_cash}}</td>
                    <td>{{item.end_cash}}</td>
                    <td>{{item.loan}}</td>
                    <td>{{item.shareholder}}</td>
                    <td>{{item.cash_count}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="audit prospectus_audit" v-if="inforList.check_status!=0">
            <p>
              <span class="audit_title">审核状态：</span>
              <span class="audit_content nopass" v-if="inforList.check_status===0">未审核</span>
              <span class="audit_content nopass" v-else-if="inforList.check_status===5">审核不合格</span>
              <span class="audit_content pass" v-else-if="inforList.check_status===10">审核合格</span> 
            </p>
            <p><span class="audit_title">审核老师：</span><span class="audit_content">{{inforList.check_name}}</span><span class="audit_title">审核时间：</span><span class="audit_content">{{inforList.check_time}}</span></p>
            <p v-if="inforList.check_status === 5"><span class="audit_title">不通过原因：</span><span class="audit_content">{{inforList.check_reson}}</span></p>
            <p v-if="inforList.check_status === 10"><span class="audit_title">审核评语：</span><span class="audit_content">{{inforList.check_comment}}</span></p>
          </div>
          <!-- <div class="audit_btn" > -->
          <div class="audit_btn" v-if="inforList.check_status != 10 ">
            <el-button type="success" @click="audit(inforList.check_status)">审核</el-button>
          </div>
        </div>
      </div>
    </div>
    <Modal :title="title" :type="type"  :final="final" v-if="showdialog" :showdialog="showdialog" @dialogConfirm="dialogConfirm" @dialogConcel="dialogConcel"></Modal>
  </div>
</template>
<script>
import Modal from '../../components/ideaModal';
  export default{
    name:'prospectusDetail',
    components:{
      Modal
    },
    data(){
      return {
        detailList:{},
        inforList:{},
        configArr:{},
        enterpriseType:[],
        enterpriseTypeOther:false,
        enterpriseOtherText:'',
        saleType:[],
        saleTypeOther:false,
        saleOtherText:'',
        registerType:[],
        registerTypeOther:false,
        registerOtherText:'',
        showdialog:false,
        type:0,
        title:'创业计划书书——审核',
        newType:'',
        final:'prospectus'
      }
    },
    created(){
      this.id = this.$route.params && this.$route.params.id
      let arr = JSON.parse(this.$store.state.config) || JSON.parse(localStorage.getItem('config'))
      this.configArr = arr.business_plan
      let params = {
        student_id:this.id,
      }
      this.getinfor(params)
    },
    mounted(){
      
    },
    methods:{
      getinfor(params){
        this.$api.user.detailSybplan(params)
          .then(res=>{
            if(res.code === 0){
              this.inforList = res.result
              let enterpriseArr = this.inforList.enterprise_category 
              let saleArr = this.inforList.sale_mode 
              let registerArr = this.inforList.register_type 
              this.configArr.enterprise_category.forEach((v,k)=>{
                if(enterpriseArr.indexOf(v.id) != -1){
                  let i = enterpriseArr.indexOf(v.id)
                  this.enterpriseType.push(this.configArr.enterprise_category[i].name)
                }
                if(enterpriseArr.indexOf(10) != -1){
                  this.enterpriseTypeOther = true
                  this.enterpriseOtherText = this.inforList.enterprise_category_other
                }
              })
              
              this.configArr.sale_mode.forEach((v,k)=>{
                if(saleArr.indexOf(v.id) != -1){
                  let i = saleArr.indexOf(v.id)
                  this.saleType.push(this.configArr.sale_mode[i].name)
                }
                // if(saleArr.indexOf(10) != -1){
                //   this.saleTypeOther = true
                //   this.saleOtherText = this.inforList.
                // }
              })
              if(Number(registerArr) === 10){
                  this.registerTypeOther = true
                  this.registerOtherText = this.inforList.register_type_other
                }
              this.configArr.enterprise_register_type.forEach((v,k)=>{
                if(Number(registerArr) === v.id){
                  this.registerType = this.configArr.enterprise_register_type[k].name
                }
              }) 
            }
          }) 
      },
      dialogConfirm(data){
        let params = {
          student_id:this.id,
          step:data.step,
          status:Number(data.status),
          check_reson:data.check_reson,
          check_score:data.check_score,
          check_comment:data.check_comment,
        }
        this.$api.user.checkSybplan(params)
        .then(res=>{
          if(res.code === 0){
            this.showdialog = false
            this.$message.success('审核成功')
            let params = {
              student_id:this.id,
            }
            this.getinfor(params)
          }
        }) 
      },
      dialogConcel(){
        this.showdialog = false
      },
      audit(status){
        this.showdialog = true
        this.type = status
      }
    },
    watch:{
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/prospectusDetail.scss';
</style>